module.exports = __webpack_public_path__ + "img/3000-box.6ff93e8e.png";